import { useParams, useSearchParams } from "react-router-dom";
import InstallmentsCalculatorFlanders from "./InstallmentsCalculatorFlanders";
import InstallmentsCalculatorGirona from "./InstallmentsCalculatorGirona";


export default function InstallmentsCalculator(){
    const { region } = useParams();
    const [searchParams] = useSearchParams();
    const flow = searchParams.get("flow"); // "classic" or "guided"

    if (region === "flanders") return <InstallmentsCalculatorFlanders flow={flow} />;
    if (region === "girona")   return <InstallmentsCalculatorGirona flow={flow} />;
}
